import {supportNative, getErrorFactory, logError} from './util';


const zzc = window.zzc;



/**
 * 设置左滑手势状态
 *
 * @export
 * @param {Number} state 状态值
 * * 0  启用默认手势效果
 * * 1  关闭手势功能
 * * 2  支持手势，但把前面所有页面都移除。
 * @returns
 */
export default function setLeftPanGesture(state = 0) {
  let errorFactory = getErrorFactory('setLeftPanGesture');

  if (!supportNative('base_controlLeftPanGesture')) {
    return logError(errorFactory('不支持zzcjsbridge'));
  }

  zzc.call('base_controlLeftPanGesture', {
    off: state,
    complete: function (res) {
      if (res.state) {
        logError(errorFactory(res.message));
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/native/setLeftPanGesture.js